import React from 'react';
import {Table} from '../../../components/table/Table';
import {UserAvatarWithNameAndEmail} from '../../reimbursement/components/ReimbursementColumnRenders';

export const LeaveCreditTable = props => {
  const {navigation} = props;
  return (
    <Table
      eventSourceId={['leaveCredit']}
      api={`/leavecredit/setup`}
      onRowPress={props => {
        const {row} = props;
        navigation.navigate(`edit-leave-credit`, {
          row,
        });
      }}
      columns={[
        {
          header: 'Employee',
          render: ({row}) => {
            return (
              <UserAvatarWithNameAndEmail
                name={row?.employee_id?.name}
                color={row?.employee_id?.color}
                official_email_id={row?.employee_id?.official_email_id}
              />
            );
          },
          minWidth: 200,
        },
        {
          header: 'Month',
          field: 'month_id.name',
          type: 'text',
          width: 150,
        },
        {
          header: 'Year',
          field: 'year_id.name',
          type: 'text',
          width: 150,
        },
        {
          header: 'Leave Credited',
          field: 'leave_credited',
          type: 'text',
          width: 150,
        },
        {
          header: 'Leave Type',
          field: 'leave_type_id.name',
          type: 'text',
          width: 150,
        },
        {
          header: 'Leave Credit Code',
          field: 'leave_credit_code',
          type: 'text',
          width: 150,
        },
        {
          header: 'From Date',
          field: 'from_date',
          type: 'date',
          width: 150,
        },
      ]}
    />
  );
};

export const EsiCycleTable = props => {
  const {navigation} = props;
  return (
    <Table
      eventSourceId={['esicycle']}
      api={`/esi/cycle`}
      onRowPress={props => {
        const {row} = props;
        navigation.navigate(`edit-esi-cycle`, {
          row,
        });
      }}
      columns={[
        {
          header: 'From Date',
          field: 'from_date',
          type: 'date',
          width: 200,
        },
        {
          header: 'To Date',
          field: 'to_date',
          type: 'date',
          width: 200,
        },
      ]}
    />
  );
};

export const SalaryCycleTable = props => {
  const {navigation} = props;
  return (
    <Table
      eventSourceId={['salarycycle']}
      api={`/salary/cycle`}
      onRowPress={props => {
        const {row} = props;
        navigation.navigate(`edit-salary-cycle`, {
          row,
        });
      }}
      columns={[
        {
          header: 'Organization',
          field: 'organization.name',
          type: 'text',
          minWidth: 200,
        },
        {
          header: 'Active From',
          field: 'active_from',
          type: 'date',
          width: 150,
        },
        {
          header: 'From',
          field: 'from',
          type: 'number',
          width: 150,
        },
        {
          header: 'To',
          field: 'to',
          type: 'number',
          width: 150,
        },
      ]}
    />
  );
};

export const TaxDeclarationSetupTable = props => {
  const {navigation} = props;
  return (
    <Table
      eventSourceId={['taxsetup']}
      api={`/taxdeclarationsections`}
      onRowPress={props => {
        const {row} = props;
        navigation.navigate(`edit-declaration-section`, {
          row,
        });
      }}
      columns={[
        {
          header: 'Name',
          field: 'name',
          type: 'text',
        },
      ]}
    />
  );
};

export const TaxSlabsTable = props => {
  const {navigation} = props;
  return (
    <Table
      eventSourceId={['taxsetup']}
      api={`/tax-slabs`}
      onRowPress={props => {
        const {row} = props;
        navigation.navigate(`edit-tax-slab`, {
          row,
        });
      }}
      columns={[
        {
          header: 'Financial Year',
          field: 'finantial_year_id.name',
          type: 'text',
          minWidth: 200,
        },
        {
          header: 'Tax Percent',
          field: 'tax_percentage',
          type: 'number',
          width: 150,
        },
        {
          header: 'To Amount',
          field: 'to_amount',
          type: 'number',
          width: 150,
        },
      ]}
    />
  );
};

export const TaxSlabsNewRegimeTable = props => {
  const {navigation} = props;
  return (
    <Table
      eventSourceId={['taxsetup']}
      api={`/tax-slabs-new-regime`}
      onRowPress={props => {
        const {row} = props;
        navigation.navigate(`edit-tax-slab-new-regime`, {
          row,
        });
      }}
      columns={[
        {
          header: 'Financial Year',
          field: 'finantial_year_id.name',
          type: 'text',
          minWidth: 200,
        },
        {
          header: 'Tax Percent',
          field: 'tax_percentage',
          type: 'number',
          width: 150,
        },
        {
          header: 'To Amount',
          field: 'to_amount',
          type: 'number',
          width: 150,
        },
      ]}
    />
  );
};

export const SavingHeadsTable = props => {
  const {navigation} = props;
  return (
    <Table
      eventSourceId={['taxsetup']}
      api={`/saving-heads`}
      onRowPress={props => {
        const {row} = props;
        navigation.navigate(`edit-saving-heads`, {
          row,
        });
      }}
      columns={[
        {
          header: 'Name',
          field: 'name',
          type: 'text',
          // width: 200,
          // width: 300
        },
        {
          header: 'Amount',
          field: 'amount',
          type: 'number',
          width: 200,
        },
        {
          header: 'Max limit',
          field: 'max_limit',
          type: 'number',
          width: 200,
        },
        {
          header: 'Is salary paid base',
          field: 'is_salary_paid_base',
          type: 'boolean',
          width: 200,
        },
        {
          header: 'Benefit Percent',
          field: 'benefit_percent',
          type: 'number',
          width: 200,
        },
      ]}
    />
  );
};
